import React from 'react';
import { InputField, ListItem } from 'vindi-ds-components';
import templates from '../templates.json';

function getCustomField(customField) {
  switch (customField.type) {
    case 'bank_slip_due_day': return <SelectBankSlipDueDay label={customField.label} options={customField.options} />;
    case 'invoice_issuing_type': return <SelectInvoiceIssuingType label={customField.label} options={customField.options} />;
    case 'nfe_io': return <SelectNfe label={customField.label} options={customField.options} />;
    case 'tag_list': {
      const helperText = templates.overrides_helper_text[customField.code] || customField.hint;
      return <InputField label={customField.label} name={`metadata_attributes.${customField.code}`} helperText={helperText} select multiTag />;
    }
    default: return (
      <InputField
        placeholder=''
        label={customField.label}
        name={`metadata_attributes.${customField.code}`}
        helperText={customField.hint}
      />
    );
  }
}

export default getCustomField;

function SelectBankSlipDueDay({ label, options }) {
  return (
    <InputField
      label={label}
      name='metadata_attributes._bank_slip_due_day'
      helperText={<>Selecione o número de dias para o vencimento dos boletos emitidos para este cliente. Escolha `Vencimento padrão` para manter a configuração original do <a href='/admin/payment_methods\'>método de pagamento</a></>}
      placeholder='Vencimento padrão'
      select
    >
      {options?.map(([days, value]) => (
        <ListItem value={String(value ?? '')} key={value}>{days}</ListItem>
      ))}
    </InputField>
  );
}

function SelectInvoiceIssuingType({ label, options }) {
  return (
    <InputField
      label={label}
      name='metadata_attributes._invoice_issuing_type'
      helperText={<>Selecione o tipo de emissão das notas fiscais deste cliente. Escolha `Emissão padrão` para manter a configuração original da integração da nota fiscal. Consulte a <a href='http://atendimento.vindi.com.br/hc/pt-br/articles/204706800' target='_blank' rel='noreferrer'>documentação</a> para mais informações sobre cada tipo de emissão.</>}
      placeholder='Emissão padrão'
      select
    >
      {options?.map(([type, value]) => (
        <ListItem value={String(value ?? '')} key={value}>{type}</ListItem>
      ))}
    </InputField>
  );
}

function SelectNfe({ label, options }) {
  return (
    <InputField
      label={label}
      name='metadata_attributes._integration_nfeio_taxation'
      helperText='Selecione o regime tributário para as notas fiscais emitidas para este cliente.'
      placeholder='Emissão padrão'
      select
    >
      {options?.map(([type, value]) => (
        <ListItem value={String(value ?? '')} key={value}>{type}</ListItem>
      ))}
    </InputField>
  );
}
